"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractStatusCard = class UcContractStatusCard extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    canTransitionTo(...args) {
        const nextStatus = args[0];
        const md = args[1];
        if (md.next_statuses.length == 0) {
            return false;
        }
        return md.next_statuses.indexOf(nextStatus) > -1;
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    states;
    ux;
    dataMembers = ['states', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                states: [{
                        value: "approved",
                        text: this.$fn.pgettext("SetContractStatus", "Approve..."),
                        variant: "light",
                    },
                    {
                        value: "signed",
                        text: this.$fn.pgettext("SetContractStatus", "Sign..."),
                        variant: "light",
                    },
                    {
                        value: "rescinded",
                        text: this.$fn.pgettext("SetContractStatus", "Rescind..."),
                        variant: "light",
                    },
                    {
                        value: "active",
                        text: this.$fn.pgettext("SetContractStatus", "Activate..."),
                        variant: "light",
                    },
                    {
                        value: "terminated",
                        text: this.$fn.pgettext("SetContractStatus", "Terminate..."),
                        variant: "light",
                    },
                    {
                        value: "ended",
                        text: this.$fn.pgettext("SetContractStatus", "End..."),
                        variant: "light",
                    },
                    {
                        value: "archived",
                        text: this.$fn.pgettext("SetContractStatus", "Archive..."),
                        variant: "light",
                    },
                ],
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_3943151158818434_emit_9182_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3943151158818434_close_9181_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_3943151158818434_showModal_9180_getActionArgs($event) {
        return {
            name: "ContractStatusTransition",
            props: {
                contract: this.contract,
                status: $event.scope.state.value,
            },
        };
    }
    async evh_3943151158818434_clickStopPrevent(event, scope) {
        return await this.actions.evh_3943151158818434_clickStopPrevent.executeFromDOM(this, event, scope);
    }
    async act_2857579216270778_emit_9186_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_2857579216270778_close_9185_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_2857579216270778_showModal_9184_getActionArgs($event) {
        return {
            name: "ContractStatusTransition",
            props: {
                contract: this.contract,
                status: "unarchive",
            },
        };
    }
    async evh_2857579216270778_clickStopPrevent(event, scope) {
        return await this.actions.evh_2857579216270778_clickStopPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_9178 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_9177 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_9178,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_9177],
        });
        const act_3943151158818434_emit_9182 = new core_1.actions.EmitAction({
            actionArgs: this.act_3943151158818434_emit_9182_getActionArgs,
            events: [],
        });
        const evh_3943151158818434_close_9181 = new core_1.actions.EventHandlerImpl({
            action: act_3943151158818434_emit_9182,
            event: "close",
            when: this.evh_3943151158818434_close_9181_getWhen,
            displayName: "emit",
        });
        const act_3943151158818434_showModal_9180 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3943151158818434_showModal_9180_getActionArgs,
            events: [evh_3943151158818434_close_9181],
        });
        const evh_3943151158818434_clickStopPrevent_9179 = new core_1.actions.EventHandlerImpl({
            action: act_3943151158818434_showModal_9180,
            event: "click.stop.prevent",
            displayName: "showModal",
        });
        const evh_3943151158818434_clickStopPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3943151158818434_clickStopPrevent_9179],
        });
        const act_2857579216270778_emit_9186 = new core_1.actions.EmitAction({
            actionArgs: this.act_2857579216270778_emit_9186_getActionArgs,
            events: [],
        });
        const evh_2857579216270778_close_9185 = new core_1.actions.EventHandlerImpl({
            action: act_2857579216270778_emit_9186,
            event: "close",
            when: this.evh_2857579216270778_close_9185_getWhen,
            displayName: "emit",
        });
        const act_2857579216270778_showModal_9184 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2857579216270778_showModal_9184_getActionArgs,
            events: [evh_2857579216270778_close_9185],
        });
        const evh_2857579216270778_clickStopPrevent_9183 = new core_1.actions.EventHandlerImpl({
            action: act_2857579216270778_showModal_9184,
            event: "click.stop.prevent",
            displayName: "showModal",
        });
        const evh_2857579216270778_clickStopPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2857579216270778_clickStopPrevent_9183],
        });
        return {
            act_7315092382398562_reloadComponentData_9178,
            evh_7315092382398562_reload_9177,
            evh_7315092382398562_reload,
            act_3943151158818434_emit_9182,
            evh_3943151158818434_close_9181,
            act_3943151158818434_showModal_9180,
            evh_3943151158818434_clickStopPrevent_9179,
            evh_3943151158818434_clickStopPrevent,
            act_2857579216270778_emit_9186,
            evh_2857579216270778_close_9185,
            act_2857579216270778_showModal_9184,
            evh_2857579216270778_clickStopPrevent_9183,
            evh_2857579216270778_clickStopPrevent,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractStatusCard.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractStatusCard.prototype, "onContract", null);
UcContractStatusCard = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractStatusCard);
exports.default = UcContractStatusCard;
vue_property_decorator_1.Vue.component("UcContractStatusCard", UcContractStatusCard);
